export const GMAP_EMBED_API_KEY = 'AIzaSyC9Ah1XFzRfaALglw0kdX4pminkMRxx0oQ'

export const mypageTabItems = [
  {
    label: '資料請求',
    link: '/mypage/document_request/list'
  },
  {
    label: '病院見学',
    link: '/mypage/visit_application/list'
  },
  {
    label: 'イベント',
    link: '/mypage/event/list'
  }
]

export const EVENT_TYPE = {
  online: 1,
  offline: 2
}
